import * as Yup from "yup"

export const addressSectionValidations = {
  address: Yup.object({
    city: Yup.string().required('Pole "Mesto" je povinné.'),
    zipCode: Yup.string().required('Pole "PSČ" je povinné.'),
    street: Yup.string().required('Pole "Ulica a číslo domu" je povinné.'),
  }),
}
